import React from "react";
import styled, { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0px;
  }
`

const Layout = styled.div`
  display:flex;
  background-image: linear-gradient(to bottom right, #10B981, #EC4899);
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const Button = styled.a`
  display: block;
  background-color: #f7f7f7;
  background-image: -webkit-gradient(linear, left top, left bottom, from(#f7f7f7), to(#e7e7e7));
  background-image: -webkit-linear-gradient(top, #f7f7f7, #e7e7e7);
  background-image: -moz-linear-gradient(top, #f7f7f7, #e7e7e7);
  background-image: -ms-linear-gradient(top, #f7f7f7, #e7e7e7);
  background-image: -o-linear-gradient(top, #f7f7f7, #e7e7e7);
  color: #a7a7a7;
  margin: 36px;
  width: 144px;
  height: 144px;
  position: relative;
  text-align: center;
  line-height: 144px;
  border-radius: 50%;
  box-shadow: 0px 3px 8px #aaa, inset 0px 2px 3px #fff;

  :before {
    content: "";
    display: block;
    background: #fff;
    border-top: 2px solid #ddd;
    position: absolute;
    top: -18px;
    left: -18px;
    bottom: -18px;
    right: -18px;
    z-index: -1;
    border-radius: 50%;
    box-shadow: inset 0px 8px 48px #ddd;
  }

  :after {
    content: "Click to increase";
  }

  :hover {
    text-decoration: none;
    color: #555;
    background: #f5f5f5;
    cursor: pointer;
  }
`

const Label = styled.div`
font-size: x-large;
`


function App() {
  const [count, setCount] = React.useState(0)
  return (
    <React.Fragment>
      <GlobalStyle />
      <Layout>
        <Button onClick={() => { setCount(prevState => (prevState + 1)) }}></Button>
        <Label>
          {count}
        </Label>
      </Layout>
    </React.Fragment>

  );
}

export default App;
